import { boolean } from '../../util/joi';
import { schema as contactPersonSchema } from './ContactPerson.schema';
import { schema as contactCompanySchema } from './ContactCompany.schema';

export const schema = (Joi: any, label: string) =>
  Joi.object()
    .keys({
      person: Joi.any(),
      company: Joi.any(),
      isCompany: boolean(Joi)
    })
    .when('.isCompany', {
      is: true,
      then: Joi.object({
        company: contactCompanySchema(Joi, label)
      }),
      otherwise: Joi.object({
        person: contactPersonSchema(Joi, label)
      })
    });

export default {
  schema
};
